// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `Edit Avatar Modal Styles
#editAvatarModalLabel {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.avatar-modal-body {
  padding: 24px;
  text-align: center;
}

.avatar-preview-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 30px;
}

.avatar-preview-container {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 2px dashed #666;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  background-color: #1a1a1a;
}

.avatar-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.avatar-edit-label {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: #22c55e;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 3px solid #12121a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.avatar-edit-label:hover {
  background: #16a34a;
  transform: scale(1.05);
}

.avatar-edit-icon {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

.avatar-file-input {
  display: none;
}

.avatar-modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn-cancel-avatar {
  padding: 12px 24px;
  background: #2a2a3a;
  border: 1px solid #2a2a3a;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel-avatar:hover {
  background: #3a3a4a;
}

.btn-apply-avatar {
  padding: 12px 24px;
  background: #ffdc88;
  border: none;
  border-radius: 8px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-apply-avatar:hover {
  background: #ffd966;
}

/* OTP Button Styles */
.otp-button-disabled {
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

.otp-button-enabled {
  cursor: pointer !important;
  opacity: 1 !important;
}

/* File Input Hidden */
.hidden-file-input {
  display: none;
}

/* Password Validation Styles */
.text-success {
  color: #22c55e !important;
}

.text-danger {
  color: #ef4444 !important;
}

/* Password Eye Button Styles */
.password-eye-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
  font-size: 18px;
  display: flex;
  align-items: center;
  transition: color 0.3s ease;
}

.password-eye-btn:hover {
  color: #808080;
}

.emailinput .d-flex {
  position: relative;
}

.emailinput input[type="password"],
.emailinput input[type="text"] {
  padding-right: 40px !important;
}

.anti-phishing-remove-trigger {
  margin-left: 8px;
}

.anti-phishing-icon-gap {
  margin-right: 6px;
}

.anti-phishing-title-icon {
  margin-right: 8px;
}

.anti-phishing-remove-info {
  margin-bottom: 24px;
}

.anti-phishing-remove-section {
  margin-bottom: 16px;
}

.anti-phishing-remove-section-last {
  margin-bottom: 0;
}

.anti-phishing-remove-heading {
  font-weight: 600;
  margin-bottom: 8px;
  color: #fff;
}

.anti-phishing-remove-copy {
  font-size: 14px;
  color: #ccc;
  line-height: 1.6;
  margin-bottom: 0;
}

.anti-phishing-remove-verify-copy {
  margin-bottom: 12px;
  color: #ccc;
}

.anti-phishing-remove-switch {
  margin-bottom: 15px;
}

.anti-phishing-remove-submit {
  background: #dc3545;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/SettingsPage/SettingsPage.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["Edit Avatar Modal Styles\n#editAvatarModalLabel {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.avatar-modal-body {\n  padding: 24px;\n  text-align: center;\n}\n\n.avatar-preview-wrapper {\n  position: relative;\n  display: inline-block;\n  margin-bottom: 30px;\n}\n\n.avatar-preview-container {\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  border: 2px dashed #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin: 0 auto;\n  overflow: hidden;\n  background-color: #1a1a1a;\n}\n\n.avatar-preview-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n  display: block;\n}\n\n.avatar-edit-label {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  background: #22c55e;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: 3px solid #12121a;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n}\n\n.avatar-edit-label:hover {\n  background: #16a34a;\n  transform: scale(1.05);\n}\n\n.avatar-edit-icon {\n  width: 20px;\n  height: 20px;\n  filter: brightness(0) invert(1);\n}\n\n.avatar-file-input {\n  display: none;\n}\n\n.avatar-modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.btn-cancel-avatar {\n  padding: 12px 24px;\n  background: #2a2a3a;\n  border: 1px solid #2a2a3a;\n  border-radius: 8px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-cancel-avatar:hover {\n  background: #3a3a4a;\n}\n\n.btn-apply-avatar {\n  padding: 12px 24px;\n  background: #ffdc88;\n  border: none;\n  border-radius: 8px;\n  color: #000;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-apply-avatar:hover {\n  background: #ffd966;\n}\n\n/* OTP Button Styles */\n.otp-button-disabled {\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n}\n\n.otp-button-enabled {\n  cursor: pointer !important;\n  opacity: 1 !important;\n}\n\n/* File Input Hidden */\n.hidden-file-input {\n  display: none;\n}\n\n/* Password Validation Styles */\n.text-success {\n  color: #22c55e !important;\n}\n\n.text-danger {\n  color: #ef4444 !important;\n}\n\n/* Password Eye Button Styles */\n.password-eye-btn {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #999;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  transition: color 0.3s ease;\n}\n\n.password-eye-btn:hover {\n  color: #808080;\n}\n\n.emailinput .d-flex {\n  position: relative;\n}\n\n.emailinput input[type=\"password\"],\n.emailinput input[type=\"text\"] {\n  padding-right: 40px !important;\n}\n\n.anti-phishing-remove-trigger {\n  margin-left: 8px;\n}\n\n.anti-phishing-icon-gap {\n  margin-right: 6px;\n}\n\n.anti-phishing-title-icon {\n  margin-right: 8px;\n}\n\n.anti-phishing-remove-info {\n  margin-bottom: 24px;\n}\n\n.anti-phishing-remove-section {\n  margin-bottom: 16px;\n}\n\n.anti-phishing-remove-section-last {\n  margin-bottom: 0;\n}\n\n.anti-phishing-remove-heading {\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #fff;\n}\n\n.anti-phishing-remove-copy {\n  font-size: 14px;\n  color: #ccc;\n  line-height: 1.6;\n  margin-bottom: 0;\n}\n\n.anti-phishing-remove-verify-copy {\n  margin-bottom: 12px;\n  color: #ccc;\n}\n\n.anti-phishing-remove-switch {\n  margin-bottom: 15px;\n}\n\n.anti-phishing-remove-submit {\n  background: #dc3545;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
